import React from 'react';
import { Box, TablePagination, Typography } from '@mui/material';
import {  FileText } from "lucide-react";


const PRListPagination = ({ 
  total, 
  page, 
  onPageChange, 
  rowsPerPage, 
  onRowsPerPageChange 
}) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        mt: 3,
        px: 1
      }}
    >
      <Typography 
        variant="body2" 
        sx={{ 
          color: '#737373',
          fontWeight: 500,
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}
      >
        <FileText size={16} />
        Showing {Math.min((page + 1) * rowsPerPage, total)} of {total} pull requests
      </Typography>
      
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={[5, 10, 25, 50]}
        sx={{
          '& .MuiTablePagination-toolbar': {
            paddingLeft: 0,
            paddingRight: 0,
          },
          '& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
            fontWeight: 600,
            fontSize: '0.875rem',
            color: '#737373'
          },
          '& .MuiTablePagination-select': {
            fontSize: '0.875rem',
            fontWeight: 500,
            color: '#737373'
          },
          '& .MuiIconButton-root': {
            color: '#737373',
            '&:hover': {
              backgroundColor: '#f0f9ff'
            },
            '&.Mui-disabled': {
              color: '#d1d5db'
            }
          }
        }}
      />
    </Box>
  );
};

export default PRListPagination;
